import React, { useState } from 'react';
import { Input } from '@vds/inputs';
import PropTypes from 'prop-types';

import { isPoBoxAddress } from '../validation';
import { eventDispatcher } from "../Tagging/index";

const ReqInput = (props) => {
  const [state, setInput] = useState({
    success: false,
    error: false,
    errorText: '',
  });

  const handlePhoneNumberError = (val, e) => {
    const inputStatusval = state;
    const phoneNumber = val.split('.').join('');
    if (phoneNumber.length === 0) {
      inputStatusval.error = true;
      inputStatusval.errorText = 'Required';
      if (e.type === 'focus' || e.type === 'keyup') {
        inputStatusval.error = false;
        inputStatusval.errorText = '';
        inputStatusval.success = false;
      }
    } else if (phoneNumber.length > 0 && phoneNumber.length < 9) {
      inputStatusval.error = true;
      inputStatusval.errorText = 'Please enter a valid 10 digit phone number.';
    } else if (phoneNumber === '0000000000' || phoneNumber === '9999999999') {
      inputStatusval.error = true;
      inputStatusval.errorText = 'Please enter a valid contact number';
    } else {
      inputStatusval.success = true;
    }
    return inputStatusval;
  };

  const checkPoBoxAddress = (address) => {
    const inputStatusval = state;
    if (address && isPoBoxAddress(address)) {

    eventDispatcher('sendData', {
      name: '',
      svars: {
        // evar221: 'AP Toggle Y',
        evar13: 'we can’t accept a PO box for shipping',
        evar22: 'message displayed',
      },
    });
      inputStatusval.error = true;
      inputStatusval.errorText = 'We are unable to ship to PO Boxes';
    } else {
      inputStatusval.success = true;
    }
    return inputStatusval;
  };

  const onChangeHandler = (e) => {
    props.onChange(e);
    handleError(e, props.hideBlur);
  };

  const handleError = (e, hideBlur = false) => {
    const targetValue = e.target.value.trim();
    let inputStatus = {
      success: false,
      error: false,
      errorText: '',
    };

    if (props.id !== 'ssn') {
      if (props.type === 'tel') {
        inputStatus = handlePhoneNumberError(targetValue, e);
      } else if (targetValue !== '' && props.id === 'adress1') {
        inputStatus = checkPoBoxAddress(targetValue);
      } else if (targetValue !== '') {
        inputStatus.success = true;
      } else {
        inputStatus.error = true;
        inputStatus.errorText = 'Required';
        if (e.type === 'focus' || e.type === 'keyup') {
          inputStatus.error = false;
          inputStatus.errorText = '';
          inputStatus.success = false;
        }
      }
    } else if (targetValue !== '') {
      inputStatus.success = true;
    } else if (targetValue === '') {
      inputStatus.error = true;
      inputStatus.errorText = 'Required';
      inputStatus.success = true;
      if (e.type === 'focus' || e.type === 'keyup') {
        inputStatus.error = false;
        inputStatus.errorText = '';
        inputStatus.success = false;
      }
    }
    if (props.id === 'promo') {
      inputStatus.error = false;
      inputStatus.errorText = 'Required';
      inputStatus.success = false;
    }
    setInput({
      inputStatus,
    });
    if (props?.onBlur && !hideBlur) {
      props.onBlur(props?.name, e);
    }
    if (props?.onKeyDown) {
      props.onKeyDown(props?.name, e);
    }
    if (props?.onFocus) {
      props.onFocus(props?.name, e);
    }
  };

  const handlePasteError = (e) => {
    e.preventDefault();
    const inputStatus = {
      success: false,
      error: true,
      errorText: "Copy paste doesn't work",
    };
    setInput({
      inputStatus,
    });
    return props.onPaste;
  };

  const { error, success, errorText } = state;
  const {
    onClickInlineAction,
    readOnly,
    mask,
    tabIndex,
    dateFormat,
    onPaste,
    onPasteError,
    value,
    helperText,
    helperTextPlacement,
    tooltipContent,
    maxLength,
    placeholder,
    id,
    width,
    optional,
    onChange,
    type,
    label,
    ariaLabel,
    analyticstrack,
    isDisabled,
    defaultValue,
    successText,
  } = props;
  const toggleProps = props.hideBlur
    ? { onChange: onChangeHandler }
    : {
        onChange,
        onBlur: (e) => handleError(e),
        onKeyDown: (e) => handleError(e),
        onKeyUp: (e) => handleError(e),
      };
  return (
    <Input
      type={type}
      // onBlur={(e) => handleError(e)}
      // onKeyDown={(e) => handleError(e)}
      // onFocus={(e) => handleError(e)}
      // onKeyUp={handleError}
      label={label}
      ariaLabel={ariaLabel}
      data-analyticstrack={analyticstrack}
      disabled={isDisabled}
      defaultValue={defaultValue}
      error={props.error || error}
      errorText={error ? errorText : props.errorText}
      success={props.success || success}
      successText={successText}
      inputId={id}
      width={width}
      optional={optional}
      // onChange={onChangeHandler}
      placeholder={placeholder}
      maxLength={maxLength}
      tooltipContent={tooltipContent}
      helperText={helperText}
      helperTextPlacement={helperTextPlacement}
      data-truevalue={undefined}
      value={value}
      onPaste={onPasteError ? handlePasteError : onPaste}
      dateFormat={dateFormat}
      tabIndex={tabIndex || 0}
      readOnly={readOnly}
      required={props.required}
      onClickInlineAction={onClickInlineAction}
      mask={mask}
      containsPii={!!props.isPiiMask}
      data-cs-mask={!!props.isCsMask}
      {...toggleProps}
    />
  );
};

Input.defaultProps = {
  error: false,
  errorText: '',
  success: false,
  isPiiMask: false,
  isCsMask: false,
  mask: '',
  hideBlur: false,
};

ReqInput.propTypes = {
  onClickInlineAction: PropTypes.func,
  readOnly: PropTypes.bool,
  tabIndex: PropTypes.any,
  dateFormat: PropTypes.any,
  onPaste: PropTypes.func,
  onPasteError: PropTypes.func,
  value: PropTypes.any,
  helperText: PropTypes.string,
  helperTextPlacement: PropTypes.string,
  tooltipContent: PropTypes.any,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  width: PropTypes.string || PropTypes.number,
  optional: PropTypes.any,
  onChange: PropTypes.func,
  type: PropTypes.string,
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  analyticstrack: PropTypes.any,
  isDisabled: PropTypes.bool,
  defaultValue: PropTypes.any,
  successText: PropTypes.string,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  required: PropTypes.bool,
  success: PropTypes.bool,
  name: PropTypes.string,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  onBlur: PropTypes.func,
  mask: PropTypes.string,
  isPiiMask: PropTypes.bool,
  isCsMask: PropTypes.bool,
  hideBlur: PropTypes.bool,
};
export default ReqInput;
